import { Component } from '@angular/core';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { HttpService } from './services/http.service';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { AtpActionsPopup, AtpActionsPopupData } from './atp-core/components/atp-actions-popup/atp-actions-popup.component';
import { AuthService } from './services/auth.service';
import { SignalrService } from './services/signalr.service';
import { AtpNotificationsService } from './atp-core/atp-notifications/atp-notifications.service';
import { AtpNotificationComponent } from './atp-core/atp-notifications/atp-notification.component';
import { DevService } from './services/dev.service';
import { CookiePolicyService } from './services/cookie-policy.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  constructor(public title: Title, public api: HttpService, public dialog: MatDialog, private _authService: AuthService, private _signalr: SignalrService, private _notifications: AtpNotificationsService,
    private _matIconRegistry: MatIconRegistry, private _domSanitazer: DomSanitizer, private _devService: DevService,
    private _cookiePolicy: CookiePolicyService) {
    title.setTitle('Главная');
  }

  ngOnInit() {
    this._matIconRegistry.addSvgIcon('product', this._domSanitazer.bypassSecurityTrustResourceUrl('assets/svg/product.svg'));
    this._matIconRegistry.addSvgIcon('nds', this._domSanitazer.bypassSecurityTrustResourceUrl('assets/svg/nds.svg'));
    this._matIconRegistry.addSvgIcon('handbook', this._domSanitazer.bypassSecurityTrustResourceUrl('assets/svg/handbook.svg'));
    this._matIconRegistry.addSvgIcon('units', this._domSanitazer.bypassSecurityTrustResourceUrl('assets/svg/units.svg'));

    if (this.api.user) {
      if (!this._devService.isDevMode || this._devService.isSocketsOn) {
        this._signalr.messages.start();
        this._signalr.messages.getEvent('SubscriptionMessage').subscribe(
          (data) => {
            this._notifications.push({ messageType: AtpNotificationComponent, data });
          }
        );
      }
    }

    this._cookiePolicy.checkAndShow();
  }

  authClick() {
    this._authService.openPopup();
  }

  logout() {
    const dialogRef = this.dialog.open(AtpActionsPopup, {
      width: '450px',
      data: new AtpActionsPopupData('Выход', 'Вы действительно хотите выйти?', 'Да', 'Нет')
    });

    dialogRef.beforeClosed().subscribe((result: boolean) => {
      if (result) {
        if (!this._devService.isDevMode || this._devService.isSocketsOn) {
          this._signalr.messages.stop();
        }
        this.api.logout();
      }
    });
  }

  ngOnDestroy(): void {
    if (!this._devService.isDevMode || this._devService.isSocketsOn) {
      this._signalr.messages.stop();
    }
  }

}
